import {Observable} from 'rxjs/Observable';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {IAuth} from '../shared/auth';
import {environment} from '../../environments/environment';

@Injectable()
export class AuthService {

  musicPointUrl: string = environment.dashboardApiUrl;
  private loggedIn = new BehaviorSubject<IAuth>(null);

  isLoggedIn() {
    return this.loggedIn.asObservable();
  }

  constructor(private http: HttpClient) { }

  login(auth: IAuth): Observable<boolean> {
    const musicPointUrl = this.musicPointUrl + '/user';

    return Observable.create(
      (observer) => {

        this.http.post<boolean>(musicPointUrl, auth).subscribe(
          (isAuth) => {
            observer.next(isAuth);
            this.loggedIn.next(isAuth ? auth : null);
          },
          (err) => {
            console.error('Error on validate the credentials.', err);
            observer.error(err);
          }
        );

      }
    );
  }

  logout(): void {
    this.loggedIn.next(null);
  }

}



// WEBPACK FOOTER //
// ./src/app/guard/auth.service.ts